import { debounce } from '@material-ui/core';

export const useDebounceSearch = (
  wait: number,
  callback: (value: string) => void,
  handleOnSearchTermChange?: (searchValue: string) => void,
) => {
  return handleOnSearchTermChange ? debounce(handleOnSearchTermChange, wait) : debounce(callback, wait);
};
